import { render, staticRenderFns } from "./AddEventSeating.vue?vue&type=template&id=1618503c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventSeating.vue"
export default component.exports